<!-- eslint-disable -->
<template>
  <div>
    <a-layout-content>
      <div class="home_wrapper">
        <div class="build_btn" @click="buildProject" data-ga-id="首页-点击新建项目">新建项目</div>
        <a-tabs :activeKey="currentKey" @change="callback">
          <a-tab-pane tab="工作进展" key="1">
            <div class="home_select" v-if="!isFlodSelect">
              <span class="label" style="min-width: 40px">筛选:</span>
              <a-select :defaultValue="statusValue" style="width: 120px; margin-right: 16px" @change="statusChange">
                <a-select-option value>全部</a-select-option>
                <a-select-option value="1">个人</a-select-option>
                <a-select-option value="2">系统</a-select-option>
              </a-select>
              <a-select :defaultValue="searchUserId" style="width: 120px; margin-right: 16px" @change="handleChange">
                <a-select-option value>全部</a-select-option>
                <a-select-option :value="userInfo.id">我的</a-select-option>
              </a-select>
              <a-select :defaultValue="typeValue" style="width: 120px" @change="typeChange">
                <a-select-option value>全部</a-select-option>
                <a-select-option value="-1">投资跟进</a-select-option>
                <a-select-option value="1">投后服务</a-select-option>
              </a-select>
            </div>
            <div class="home_top flex">
              <div v-if="isFlodSelect" style="display: flex">
                <a-select :defaultValue="statusValue" style="width: 120px; margin-right: 16px" @change="statusChange">
                  <a-select-option value>全部</a-select-option>
                  <a-select-option value="1">个人</a-select-option>
                  <a-select-option value="2">系统</a-select-option>
                </a-select>
                <a-select :defaultValue="searchUserId" style="width: 120px; margin-right: 16px" @change="handleChange">
                  <a-select-option value>全部</a-select-option>
                  <a-select-option :value="userInfo.id">我的</a-select-option>
                </a-select>
              </div>
              <span class="label" style="min-width: 40px">标签:</span>
              <div class="tag-div">
                <div style="cursor: not-allowed; display: flex; flex-wrap: wrap">
                  <tag
                    v-for="(item, index) in tagsList"
                    :key="index"
                    :code="item.id"
                    @change="tagsChange"
                    style="margin-right: 5px"
                    :class="showTags ? '' : 'disabledTag'"
                    :closeAll="showTags"
                    >{{ item.name }}</tag
                  >
                </div>
              </div>
              <a-button type="link" v-if="isFlodSelect" @click="isFlodSelect = false">展开<a-icon type="down"/></a-button>
              <a-button type="link" v-else @click="isFlodSelect = true">收起<a-icon type="up"/></a-button>
            </div>
            <div class="home_content">
                <a-row>
                  <a-col :span="18">
                    <a-spin :spinning="loading" style="padding: 20px 0">
                      <dataItem v-show="companyNotes.length !== 0" :companyNotes="companyNotes" :loading="loading" @delete="initialize" @update="updateData"></dataItem>
                      <div class="load_more" v-show="companyNotes.length != 0 && load_more">
                        <a-button class="load_more_btn" data-ga-id="首页-工作进展-点击加载更多" :loading="loading" @click="loadMore">加载更多</a-button>
                      </div>
                      <a-empty :image="simpleImage" v-show="companyNotes.length === 0 "/>
                    </a-spin>
                  </a-col>
                  <a-col :span="6"></a-col>
                </a-row>
            </div>
          </a-tab-pane>
          <a-tab-pane tab="观察仓" key="2" forceRender>
            <a-row>
              <a-col :span="12">
                <a-list class="loadmore-list" :loading="newsloading" itemLayout="horizontal" :dataSource="newsList">
                  <div v-if="showLoadingMore" slot="loadMore" :style="{ textAlign: 'center', marginTop: '12px', height: '32px', lineHeight: '32px' }">
                    <a-spin v-if="loadingMore" />
                    <a-button v-else @click="onLoadMore">加载更多</a-button>
                  </div>
                  <a-list-item slot="renderItem" slot-scope="item, index">
                    <div class="news_flex">
                      <div class="news_left">
                        <div>
                          <a-avatar shape="square" :size="40" class="logo" :src="item.project.logo" />
                          <a class="name">{{ item.project.name }}</a>
                          <span class="label">阶段：</span>
                          <a class="name">{{ item.project.state }}</a>
                        </div>
                        <div class="description">
                          <span>{{ item.news.title }}</span>
                          <a v-if="item.news.link" target="_blank" :href="item.news.link" style="margin-left: 16px">链接</a>
                        </div>
                      </div>
                      <div class="publishTime">{{ item.news.publishTime }}</div>
                    </div>
                  </a-list-item>
                </a-list>
              </a-col>
              <a-col :span="12"></a-col>
            </a-row>
          </a-tab-pane>
          <a-tab-pane tab="业务推进情况" key="3" forceRender v-if="permissions.dashboard">
            <dashboard></dashboard>
          </a-tab-pane>
        </a-tabs>
      </div>
    </a-layout-content>
    <a-modal
      class="project-config-modal"
      :width="900"
      v-model="projectModal.modalStatus"
      :title="projectModal.modalTitle"
      :footer="null"
      :keyboard="false"
      :maskClosable="false"
    >
      <project-edit
        v-if="projectModal.modalStatus"
        @update="gotoDetail"
        @close="projectModal.modalStatus = false"
        :usefor="'dialog'"
        ref="projectconfg"
      ></project-edit>
    </a-modal>
  </div>
</template>
<script>
/* eslint-disable */
import { mapGetters } from 'vuex';
import { Empty } from 'ant-design-vue';
import dataItem from 'components/home/dataItem';
import dashboard from 'components/home/dashboard';
import projectEdit from '@/components/project/projectEdit';
import tag from 'components/base/tag';
import { getCompanyNotes, news } from '@/api/work';
import { tagList } from '@/api/tags';
import { hasPermission } from '@/utils/utils';
import store from '@/store';
import { gaUploadCustomEvent } from '@/assets/js/ga';

export default {
  components: {
    dataItem,
    tag,
    projectEdit,
    dashboard
  },
  data() {
    return {
      loading: false,
      companyNotes: [],
      tagsList: [],
      tags: [],
      page: 1,
      pageSize: 25,
      searchUserId: '',
      statusValue: '1',
      load_more: true,
      currentKey: this.$route.query.tab || '1',
      pageNum: 1,
      newsList: [],
      newsloading: true,
      loadingMore: false,
      showLoadingMore: true,
      projectModal: {
        modalStatus: false,
        modalTitle: '项目信息'
      },
      permissions: {
        dashboard: false
      },
      isFlodSelect: true,
      typeValue: '-1',
      showTags: true,
      
    };
  },
  computed: {
    ...mapGetters(['userInfo'])
  },
  watch: {
    currentKey() {
      if (this.currentKey == '1') {
        this.companyNotes = [];
        this.getCompanyNotes();
        this.tagList();
      } else if (this.currentKey == '2') {
        this.getNews();
      }
    },

    typeValue(val) {
      if (val === '1') {
        this.showTags = false;
        this.tags = [];
      } else {
        this.showTags = true;
      }
    }
  },
  beforeCreate() {
    this.simpleImage = Empty.PRESENTED_IMAGE_SIMPLE;
  },
  created() {
    this.getPermissions();
    if (this.currentKey == '1') {
      this.getCompanyNotes();
      this.tagList();
    } else if (this.currentKey == '2') {
      this.getNews();
    }
  },
  methods: {
    buildProject() {
      this.projectModal.modalStatus = true;
    },
    gotoDetail(projectId) {
      if (projectId !== null && projectId !== undefined) {
        this.$router.push({
          path: '/project/detail',
          query: { id: projectId }
        });
      }
    },
    callback(key) {
      this.currentKey = key;
      this.$router.push(`${this.$route.path}?tab=${key}`);
    },
    async getNews() {
      this.newsloading = true;
      const res = await news({
        page: this.pageNum,
        pageSize: 10
      });
      this.newsloading = false;
      if (res.code === 200) {
        this.newsList = res.data.list;
        if (res.data.total > 10) {
          this.showLoadingMore = true;
        } else {
          this.showLoadingMore = false;
        }
      }
    },
    async onLoadMore() {
      ++this.pageNum;
      this.loadingMore = true;
      const res = await news({
        page: this.pageNum,
        pageSize: 10
      });
      this.loadingMore = false;
      if (res.code === 200) {
        this.newsList = this.newsList.concat(res.data.list);
        if (res.data.total > this.newsList.length) {
          this.showLoadingMore = true;
        } else {
          this.showLoadingMore = false;
        }
      }
    },
    tagsChange(obj) {
      if (obj.flag) {
        this.tags.push(obj.code);
      } else {
        this.tags.splice(this.tags.indexOf(obj.code), 1);
      }
      this.page = 1;
      this.companyNotes = [];
      this.$ga.gaUploadCustomEvent('首页-工作进展-筛选标签',this.tags.join(','));
      this.getCompanyNotes();
    },
    tagList() {
      tagList('notes').then(res => {
        this.tagsList = res.data.filter(_ => _.id !== 64);
      });
    },
    loadMore() {
      ++this.page;
      this.getCompanyNotes();
    },
    async getCompanyNotes() {
      try {
        this.loading = true;
        let scrollTop = document.documentElement.scrollTop;
        let tagIds;
        if (this.typeValue === '1') {
          tagIds = 64;
        } else {
          if (this.tags.length > 0) {
            tagIds = this.tags.join(',');
          } else {
            tagIds = this.typeValue === '-1' ? -1 : '';
          }
        }
        const res = await getCompanyNotes({
          tagIds: tagIds,
          type: this.statusValue,
          searchUserId: this.searchUserId,
          page: this.page,
          pageSize: this.pageSize
        });
        this.loading = false;
        if (res.code === 200) {
          if (res.data.list) {
            this.load_more = true;
            let list = res.data.list;
            list.forEach(item => {
              item.isEdit = false;
              item.isComent = false;
              item.isShow = false;
              item.isunfold = true;
            });
            // list = list.filter(item => item.owners)
            this.companyNotes = this.companyNotes.concat(list);
            this.$nextTick(() => {
              document.documentElement.scrollTop = scrollTop;
            });
            if (this.page * this.pageSize >= res.data.total) {
              this.load_more = false;
            }
          } else {
            this.load_more = false;
          }
        } else {
          this.companyNotes = [];
        }
      } catch (error) {
        console.log(error);
      }
    },
    initialize(id) {
      this.companyNotes.forEach((item, index) => {
        if (item.id === id) {
          this.companyNotes.splice(index, 1);
        }
      });
    },
    async updateData(id) {
      const res = await getCompanyNotes({
        type: this.statusValue, //这里用5@qq.com测出来一个bug
        tagIds: this.tags.join(','),
        searchUserId: this.searchUserId,
        page: 1,
        pageSize: this.companyNotes.length
      });
      if (res.code === 200) {
        if (res.data.list) {
          let list = res.data.list;
          list.forEach((item, index) => {
            item.isEdit = false;
            item.isComent = false;
            item.isShow = false;
            item.isunfold = true;
            if (item.id === id) {
              const targetIndex = this.companyNotes
                .map(item => {
                  return item.id;
                })
                .indexOf(id);
              this.companyNotes.splice(targetIndex, 1, item);
            }
          });
        }
      }
    },
    statusChange(value) {
      this.$ga.gaUploadCustomEvent('首页-工作进展-筛选【系统/个人】',value);
      this.statusValue = value;
      this.page = 1;
      this.companyNotes = [];
      this.getCompanyNotes();
    },
    handleChange(value) {
      this.$ga.gaUploadCustomEvent('首页-工作进展-筛选【我的/全部】',value);
      this.searchUserId = value;
      this.page = 1;
      this.companyNotes = [];
      this.getCompanyNotes();
    },
    getPermissions() {
      const { permissions: queue } = this.userInfo || {};
      this.permissions.dashboard = hasPermission(queue, '/dashboard');
    },
    typeChange(value) {
      this.$ga.gaUploadCustomEvent('首页-工作进展-筛选【投资/投后】',value);
      this.typeValue = value;
      this.page = 1;
      this.companyNotes = [];
      this.getCompanyNotes();
    }
  }
};
</script>
<style lang="less" scoped>
.news_flex {
  display: flex;
  width: 100%;
  justify-content: space-between;
  .logo {
    margin-right: 5px;
  }
  .label {
    display: inline-block;
    margin-left: 24px;
  }
  .description {
    color: #999;
    font-size: 12px;
    padding: 16px 0;
  }
  .news_left {
    width: calc(100% - 150px);
  }
  .publishTime {
    width: 180px;
    text-align: right;
  }
}
.name {
  font-size: 14px;
  color: #000;
  font-weight: bold;
}
.home_wrapper {
  background: #fff;
  font-size: 12px;
  padding: 16px;
  min-width: 1160px;
  min-height: 100vh;
  .build_btn {
    position: absolute;
    left: 75%;
    background: rgba(0, 144, 250);
    color: white;
    width: 70px;
    height: 30px;
    transform: translateX(-80px);
    line-height: 30px;
    text-align: center;
    cursor: pointer;
    z-index: 1;
  }
  .tap {
    width: 200px;
    text-align: center;
    padding-bottom: 5px;
    border-bottom: 2px solid #1890ff;
    margin-bottom: 20px;
  }
  .home_top {
    color: #000;
  }
  .label {
    margin: 0 16px;
  }
  .home_select {
    margin-bottom: 16px;
    color: #000;
  }
  .home_content {
    padding-bottom: 40px;
    .load_more {
      text-align: center;
      .load_more_btn {
        width: 100%;
      }
    }
  }
}
.flex {
  display: flex;
  align-items: center;
  // flex-wrap: wrap;
}
.disabledTag {
  filter: grayscale(100%);
  // cursor: not-allowed;
  pointer-events: none;
  color: rgba(0,0,0,0.45);
  // background-color: white;
  // opacity: 0.6;
}
.tag-div {
  overflow: hidden;
  height: 24px;
  // display: flex;
  // flex-wrap: wrap;
}
</style>
